/* Sibia theme: global behavior (menu, cart drawer, ajax add to cart, sliders, filters, recently viewed) */
(function () {
  'use strict';

  var config = window.themeConfig || {};
  var routes = config.routes || {};
  var strings = config.strings || {};

  function $(selector, context) { return (context || document).querySelector(selector); }
  function $$(selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) { throw json; }
        return json;
      });
    });
  }

  /* Announcement bar ----------------------------------------------------- */
  function initAnnouncement(root) {
    if (!root || root.dataset.init) { return; }
    root.dataset.init = '1';
    var items = $$('.announcement__item', root);
    if (items.length < 2) { return; }
    var speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;
    var index = 0;
    setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, speed);
  }

  /* Mobile menu ---------------------------------------------------------- */
  function setMenu(open) {
    var menu = $('[data-mobile-menu]');
    if (!menu) { return; }
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('no-scroll', open);
  }

  /* Cart drawer ---------------------------------------------------------- */
  function getDrawer() { return $('[data-cart-drawer]'); }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) { return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) { return; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
  }

  function refreshCart() {
    var sectionsUrl = (routes.root || '/') + '?sections=cart-drawer';
    return Promise.all([
      fetchJSON(routes.cartJson),
      fetchJSON(sectionsUrl)
    ]).then(function (results) {
      var cart = results[0];
      var sections = results[1] || {};
      updateCount(cart.item_count);
      if (sections['cart-drawer']) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) { current.innerHTML = fresh.innerHTML; }
      }
      return cart;
    });
  }

  function updateLine(line, quantity) {
    var drawer = getDrawer();
    if (drawer) { drawer.classList.add('is-loading'); }
    return fetchJSON(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    }).then(refreshCart).catch(function () {
      return refreshCart().catch(function () {});
    }).then(function () {
      if (drawer) { drawer.classList.remove('is-loading'); }
    });
  }

  function showFormError(form, message) {
    var el = $('[data-form-error]', form);
    if (!el) {
      el = document.createElement('p');
      el.className = 'form-message form-message--error';
      el.setAttribute('role', 'alert');
      el.setAttribute('data-form-error', '');
      form.appendChild(el);
    }
    el.textContent = message;
    el.hidden = false;
  }

  function clearFormError(form) {
    var el = $('[data-form-error]', form);
    if (el) { el.hidden = true; el.textContent = ''; }
  }

  function addToCart(form) {
    var button = $('[data-atc-button]', form);
    var idInput = $('[name="id"]', form);
    var qtyInput = $('[name="quantity"]', form);
    if (!idInput || !idInput.value) { return; }

    var items = [{
      id: parseInt(idInput.value, 10),
      quantity: Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1)
    }];

    var root = form.closest('[data-product-section]');
    if (root) {
      $$('[data-pair-input]:checked', root).forEach(function (box) {
        items.push({ id: parseInt(box.value, 10), quantity: 1 });
      });
    }

    clearFormError(form);
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }

    fetchJSON(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      if (config.cartBehavior === 'page' || !getDrawer()) {
        window.location.href = routes.cart;
        return null;
      }
      return refreshCart().then(openDrawer);
    }).catch(function (error) {
      var message = (error && (error.description || error.message)) || strings.error;
      showFormError(form, message);
    }).then(function () {
      if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form[data-ajax-atc]')) {
      event.preventDefault();
      addToCart(form);
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) { return; }

    if (target.closest('[data-menu-open]')) { event.preventDefault(); setMenu(true); return; }
    if (target.closest('[data-menu-close]')) { setMenu(false); return; }

    var cartOpen = target.closest('[data-cart-open]');
    if (cartOpen && config.cartBehavior === 'drawer' && getDrawer() && !event.metaKey && !event.ctrlKey) {
      event.preventDefault();
      openDrawer();
      refreshCart().catch(function () {});
      return;
    }
    if (target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var remove = target.closest('[data-cart-remove]');
    if (remove && remove.closest('[data-cart-drawer]')) {
      event.preventDefault();
      updateLine(remove.getAttribute('data-line'), 0);
      return;
    }

    var step = target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('[data-qty]');
      var input = wrap && $('[data-qty-input]', wrap);
      if (!input) { return; }
      var min = input.hasAttribute('min') ? parseInt(input.getAttribute('min'), 10) : 0;
      var next = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10);
      if (next < min) { next = min; }
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var prev = target.closest('[data-scroller-prev]');
    var nextBtn = target.closest('[data-scroller-next]');
    if (prev || nextBtn) {
      var scroller = (prev || nextBtn).closest('.scroller');
      var track = scroller && $('[data-scroller-track]', scroller);
      if (track) {
        track.scrollBy({ left: (prev ? -1 : 1) * track.clientWidth * 0.8, behavior: 'smooth' });
      }
      return;
    }

    var filterToggle = target.closest('[data-filter-toggle]');
    if (filterToggle) {
      var filters = $('[data-filters]');
      if (filters) {
        var open = filters.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) { return; }

    var qty = target.closest('[data-qty-input]');
    if (qty) {
      if (qty.closest('[data-cart-drawer]')) {
        updateLine(qty.getAttribute('data-line'), Math.max(0, parseInt(qty.value, 10) || 0));
      } else if (qty.closest('[data-cart-form]')) {
        qty.closest('form').submit();
      }
      return;
    }

    var auto = target.closest('[data-auto-submit]');
    if (auto) {
      var form = auto.form || auto.closest('form');
      if (form) { form.submit(); }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
      setMenu(false);
    }
  });

  /* Slideshow ------------------------------------------------------------ */
  function initSlideshow(root) {
    if (!root || root.dataset.init) { return; }
    root.dataset.init = '1';
    var track = $('[data-slideshow-track]', root);
    var slides = $$('[data-slide]', root);
    var dots = $$('[data-dot]', root);
    if (!track || slides.length < 2) { return; }

    var index = 0;
    var timer = null;

    function setActive(i) {
      index = i;
      dots.forEach(function (dot, n) { dot.classList.toggle('is-active', n === i); });
    }

    function go(i) {
      var target = (i + slides.length) % slides.length;
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
      setActive(target);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) { return; }
      ticking = true;
      window.requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / (track.clientWidth || 1)));
        ticking = false;
      });
    }, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-dot'), 10)); restart(); });
    });

    function start() {
      if (root.dataset.autoplay !== 'true') { return; }
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (window.Shopify && window.Shopify.designMode) { return; }
      var speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;
      timer = setInterval(function () { go(index + 1); }, speed);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', restart);
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('shopify:block:select', function (event) {
      var i = slides.indexOf(event.target);
      if (i > -1) { go(i); }
    });
    start();
  }

  /* Recently viewed ------------------------------------------------------ */
  var RV_KEY = 'theme_recently_viewed';

  function readViewed() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  }
  function writeViewed(list) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }
  function trackProduct() {
    var section = $('[data-product-section]');
    if (!section || !section.dataset.productHandle) { return; }
    var handle = section.dataset.productHandle;
    var list = readViewed().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeViewed(list);
  }

  function formatMoney(cents, format) {
    var template = (format || '{{amount}}').replace(/<[^>]*>/g, '');
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var whole = cents % 100 === 0;

    function number(value, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var fixed = (value / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }

    var match = template.match(pattern);
    var key = match ? match[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals': out = number(cents, 0); break;
      case 'amount_with_comma_separator': out = number(cents, whole ? 0 : 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = number(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = number(cents, whole ? 0 : 2, '\'', '.'); break;
      case 'amount_no_decimals_with_space_separator': out = number(cents, 0, ' '); break;
      case 'amount_with_space_separator': out = number(cents, whole ? 0 : 2, ' ', ','); break;
      default: out = number(cents, whole ? 0 : 2);
    }
    return template.replace(pattern, out);
  }

  function buildViewedCard(product) {
    var card = document.createElement('article');
    card.className = 'card';

    var media = document.createElement('a');
    media.className = 'card__media card__media--portrait';
    media.href = product.url;
    media.setAttribute('aria-label', product.title);
    if (product.featured_image) {
      var img = document.createElement('img');
      var src = product.featured_image;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      img.alt = product.title;
      img.loading = 'lazy';
      img.className = 'card__img card__img--primary';
      media.appendChild(img);
    }
    card.appendChild(media);

    var body = document.createElement('div');
    body.className = 'card__body';
    var title = document.createElement('h3');
    title.className = 'card__title';
    var link = document.createElement('a');
    link.href = product.url;
    link.textContent = product.title;
    title.appendChild(link);
    body.appendChild(title);

    var price = document.createElement('div');
    price.className = 'price';
    var current = document.createElement('span');
    current.className = 'price__current';
    current.textContent = formatMoney(product.price, config.moneyFormat);
    price.appendChild(current);
    if (product.compare_at_price && product.compare_at_price > product.price) {
      var compare = document.createElement('s');
      compare.className = 'price__compare';
      compare.textContent = formatMoney(product.compare_at_price, config.moneyFormat);
      price.appendChild(compare);
    }
    body.appendChild(price);
    card.appendChild(body);
    return card;
  }

  function initRecent(root) {
    if (!root || root.dataset.init) { return; }
    root.dataset.init = '1';
    var limit = parseInt(root.dataset.limit, 10) || 4;
    var current = root.dataset.current;
    var handles = readViewed().filter(function (h) { return h !== current; }).slice(0, limit);
    var grid = $('[data-rv-grid]', root);
    if (!handles.length || !grid) { return; }

    Promise.all(handles.map(function (handle) {
      return fetch((routes.root || '/') + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) { return; }
      grid.innerHTML = '';
      valid.forEach(function (product) {
        var item = document.createElement('div');
        item.className = 'product-grid__item';
        item.appendChild(buildViewedCard(product));
        grid.appendChild(item);
      });
      root.hidden = false;
    });
  }

  /* Init ----------------------------------------------------------------- */
  function init(context) {
    $$('[data-announcement]', context).forEach(initAnnouncement);
    $$('[data-slideshow]', context).forEach(initSlideshow);
    $$('[data-recently-viewed]', context).forEach(initRecent);
  }

  function initAll() {
    init(document);
    trackProduct();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
